<template>
    <div class="reuse-category-wrp" v-if="show">
        <div class="content">
            <div
                v-if="loading"
                v-loading="loading"
                element-loading-text="AI智能预测中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                style="padding: 25px"
            ></div>
            <!-- 预测结果展示 -->
            <template v-else>
                <div v-if="platform === 'fxg'"> <i class="el-icon-warning-outline icon"></i>平台接口限制，仅可使用平台预测类目，若无平台预测类目或平台预测类目不符合理，建议调整商品名称，将更新平台预测类目</div>
                <div v-if="promptText" class="prompt-text"><i class="el-icon-warning-outline icon"></i>{{ promptText }}</div>
                <div class="prediction-box">
                    <div v-for="(item, index) in predictionCategory" :key="index" class="prediction-item">
                        <div class="descrip">
                            <el-tag style="margin-right:4px" v-if="index == 0" type="danger" size="mini">推荐</el-tag>
                            <div class="category-path">{{item.cidNames.join('>')}}</div>
                            <el-button type="link" @click="useCategory(item)">点击使用</el-button>
                        </div>
                    </div>
                    <!-- 无数据提示 -->
                    <div v-if="!predictionCategory.length" class="no-data">
                        暂无预测类目数据
                    </div>
                </div>
            </template>
        </div>
        <i v-if="platform !== 'fxg'" class="el-icon-close delete-icon" @click="hide"></i>
    </div>
</template>

<script>
import { publishFastPrediction }  from '@/api/prod/center/index';
import { getPredictionCat }  from '@/api/prod/center/shopGoods.js';
import {mapGetters} from 'vuex';

export default {
    inject: {
        openSource:{default:null}
    },
    props: {
        platform: {
            type: String,
            default: null
        },
        baseItemId: {
            type: [Number, String],
            default: ''
        },
        shopId: {
            type: [String, Number],
            default: ''
        },
        categoryIds: {
            type: String | Array,
            default: [] | ''
        },
        inputText: {
            type: [String, Number],
            default: ''
        }
    },
    computed: {
        ...mapGetters(['shops_authorizedShops']),
    },
    data() {
        return {
            checkHitData: {},
            show: false,
            names: [],
            promptText: this.platform !== 'fxg' ? '系统已自动预测类目' : '',
            categoryObj: {},
            predictionCategory:[],
            loading: false,  // 添加loading状态
            effectiveShop: false,
            fxgRecommendId:''
        }
    },
    mounted() {
        // 抖音平台在平台资料手动发起
        this.platform !== 'fxg' && this.handlePredictCate()
    },
    methods: {
        hide() {
            this.show = false;
        },
        // 使用预测的类目
        useCategory(category) {
            if (category?.cidS) {
                this.$emit('updateIds', {
                    ids: category.cidS,
                    names: category.cidNames
                });
            }
            this.show = this.platform === 'fxg' ? true : false;
        },
     
        async handlePredictCate(payload = {}){
            // 必须有 baseItemId 和 platform 才能预测
            if (!this.baseItemId || !this.platform) {
                return;
            }
            // 判断店铺有效性
            const shopList = this.shops_authorizedShops(this.platform);
            this.effectiveShop = shopList.some(item => (item.deadline && item.deadline > Date.now()))
            if(this.effectiveShop || this.shopId){
                await this.getCategoryFromAi(payload)
                payload?.predictionedFn && payload.predictionedFn(this.predictionCategory)
            } 
        },
        // 统一获取平台的ai类目
        async getCategoryFromAi(payload =  { title: '',extraParams:{} }) {
            if(this.platform != 'fxg' && this.openSource === 'shopGoods') return // 除抖音外店铺商品的编辑不需要调类目预测接口
            if(this.platform != 'fxg' && this.categoryIds.length) return
            this.show = true;
            this.loading = true;  // 开始加载
            try {
                const convertMap = { 'alibaba': '1688' }
                const platformType = convertMap[this.platform] || this.platform
                let params = {
                    baseItemId: this.baseItemId,
                    platformType,
                    title: payload.title || '',
                }
                if(this.platform == 'tm'){
                    params.shopId = this.shopId
                }
                let res;
                if(this.openSource === 'shopGoods'){
                    const { itemInfo,shopId,platform,platformItemId } = payload.extraParams
                    res = await getPredictionCat({itemInfo:{name:itemInfo.name,pic:itemInfo.pic.join(',')},shopId,platform,platformItemId,});
                }else{
                    res = await publishFastPrediction(params, { isNeedLoading: false });
                }
                if(res.data && res.data.extendValue && this.platform == 'fxg'){
                    this.fxgRecommendId = res.data.extendValue.fxgRecommendId
                     // 向父组件发送值和验证状态
                    this.$emit('fxgRecommendId-change', res.data.extendValue.fxgRecommendId);
                }
                
                if(res?.data?.catList?.length) {
                    this.predictionCategory = res.data.catList;
                } else {
                    this.predictionCategory = [];
                    this.show = false;
                    // this.$message.warning(res.message || '暂无预测类目');
                }
            } catch (error) {
                this.predictionCategory = [];
                this.show = false;
                // this.$message.error(error.message || '获取预测类目失败');
            } finally {
                this.loading = false;  // 结束加载
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.reuse-category-wrp{
    margin-top: 6px;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    padding: 10px;
    display: flex;
    .icon {
        color: #faad14;
        font-size: 24px;
        margin-right: 5px;
    }
    .delete-icon {
        cursor: pointer;
    }


    .content {
        flex: 1 1;
        .prompt-text {
            margin-bottom: 12px;
            color: rgba(0,0,0,.85);
            font-size: 14px;
            font-weight: 600;
        }
        .prediction-box{
            display: flex;
            flex-wrap: wrap;
            flex-direction: row;
        }
        .prediction-item {
            margin-right: 8px;
            &:last-child {
                margin-bottom: 0;
            }
            .descrip {
                display: inline-flex;
                align-items: center;
                background: white;
                padding: 4px 0px 4px 8px;
                .category-path {
                    flex: 1;
                    color: #666;
                }
                .score {
                    margin: 0 16px;
                    color: #ff4d4f;
                }
            }
        }

        .loading-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px 0;
            
            .loading-text {
                margin-left: 10px;
                color: #666;
                font-size: 14px;
            }
        }
        
        .no-data {
            text-align: center;
            color: #999;
            padding: 10px 0;
        }
    }
}
</style>